import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Chip } from '@mui/material';

type ProductTypeTagProps = {
  type: string;
};

export const ProductTypeTag = ({ type }: ProductTypeTagProps) => {
  const getColor = () => {
    switch (type) {
      case 'pension':
        return '#1976d2';
      case 'income':
        return '#ed6c02';
      default:
        return '#e0e0e0';
    }
  };

  if (!type || (type !== 'pension' && type !== 'income')) {
    return null;
  }

  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={1}>
      <Chip
        label={<FormattedMessage id={`products.type.${type}`} />}
        sx={{ backgroundColor: getColor(), color: '#fff' }}
        size="small"
      />
    </Box>
  );
};
